﻿import { get, initForm } from "@/Utils";
import { initIdAndMobileLogin } from "@/sharedComponents/Header/Login";
import { StatusCodes } from "http-status-codes";
import {initToggleButtons, initPasswordChecks, validateRegistrationEmail} from "@/RegistrationModule";
import {validateForm} from "@/Validation.js";

function executeRegisterAccount(response: Response) {
  if (response.status === StatusCodes.OK) {
    window.location.replace(window.config.homeUrl);
  }
  return response.text().then(text => {
    if(response.status === StatusCodes.IM_A_TEAPOT){
        window.location.href = text;
    }
    get("registration").innerHTML = text;
    initView();
  });
};

function formPosted(response: Response) {
  if (response.url.endsWith("RegisterAccount")) {
    return executeRegisterAccount(response);
  }
  return () => { };
}

function initEmailRegistration(){
    const form = get("register-email-form") as HTMLFormElement;
    form?.addDataBoundEventListener("submit", (e) =>{
        e.preventDefault();
        if(!validateForm(form)) return;
        validateRegistrationEmail(form)
    })
}

function initView() {
  initToggleButtons();
  initIdAndMobileLogin(true)
  initIdAndMobileLogin(false)
  initForm("regForm", formPosted);
  initPasswordChecks()
  initEmailRegistration()
}


window.addEventListener("load", () => {
  initView();
});